import { KeycloakTokenParsed } from 'keycloak-js'
import Cookies from 'js-cookie'

type Token = KeycloakTokenParsed & TokenCustomerPortalAttributes

interface TokenCustomerPortalAttributes {
  partnerProxyId: string
  accountId: string
  idLevel: number
  migrated: string
}

function getTokenParsed(): Token | undefined {
  return window.keycloak.tokenParsed as Token
}

export async function getToken(): Promise<string | undefined> {
  await window.keycloak.updateToken(minValidityInSeconds)
  return window.keycloak.token
}

export function getPartnerProxyId(): string | null {
  const token = getTokenParsed()
  if (token !== undefined) {
    return token.partnerProxyId
  }
  return null
}

export function getIdLevel(): number | null {
  const token = getTokenParsed()
  if (token !== undefined) {
    return token.idLevel
  }
  return null
}

export function getMigrated(): string | null {
  const token = getTokenParsed()
  if (token !== undefined) {
    return token.migrated
  }
  return null
}

export function getAccountId(): string | null {
  const token = getTokenParsed()
  if (token !== undefined) {
    return token.accountId
  }
  return null
}

export function isAuthenticated(): boolean {
  if (window.keycloak.authenticated !== undefined) {
    return window.keycloak.authenticated
  }
  return false
}

export const minValidityInSeconds = 30

// Function to set cookies for Sitecore header functions
// cp_login to control login status
// refresh_token for logout functionality
const CP_LOGIN = 'cp_login'
const REFRESH_TOKEN = 'refresh_token'
export function setSitecoreCookies(refresh_token: string | undefined): void {
  const shouldReload = Cookies.get(CP_LOGIN) === undefined && window.location.hostname.includes('zurich')
  setSecret(CP_LOGIN, String(true))
  if (refresh_token !== undefined) {
    setSecret(REFRESH_TOKEN, String(refresh_token))
  }
  // we set the cp_login cookie after the page load.
  // That means that the sitecore header does not automatically update
  // We enforce a page reload here to update the sitecore header status
  window.dispatchEvent(
    new CustomEvent('cp_login_successful', {
      bubbles: true,
      detail: {}
    })
  )
  if (shouldReload) window.location.reload()
}

export function setSecret(name: string, value: string): void {
  Cookies.set(name, value, { sameSite: 'lax', domain: extractTopDomainFromHostname() })
}

function extractTopDomainFromHostname(): string {
  const hostnameParts = window.location.hostname.split('.')

  if (hostnameParts.length < 3) {
    return window.location.hostname
  } else {
    return hostnameParts[hostnameParts.length - 2] + '.' + hostnameParts[hostnameParts.length - 1]
  }
}
